import { BzModalHeader, BzModal, BzCard, BzChip, BzButton, BzModalBody } from "../../components";
import { Container, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from 'react-redux';
import { memo } from "react";
import { handleModal } from "../../redux/actions/modals";
import DontMissChip from "../DontMiss/DontMissChip";
import PriceFormat from "./PriceFormat";
import { WATCHLIST_GRID_INDEX } from "../../utils/global_variables";



const FollowUpModal = ({ followUpCompany, WatchlistGridPopoverName, setFollowUpCompany, onClickOnRecommendationCard, handleRecommendationBuySellButton, handleChildRecommendationBuySellButton, openAnalyticReport, isRecommendationExpired }) => {// Prachi T :BT-107377 - 23-11-2023 ScripInnfo recommendations

    const dispatch = useDispatch();
    const modals = useSelector(state => state?.modals?.modals);

    const handleClose = () => {
        dispatch(handleModal([{ "RECOMMENDATION_FOLLOW_UP_MODAL": false }]));
        setFollowUpCompany({});
    };

    return (
        <BzModal size='md' show={modals['RECOMMENDATION_FOLLOW_UP_MODAL']} onHide={handleClose} centered>
            <BzModalHeader className='modaltabs-header'>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col md={11} className='d-flex justify-content-start align-items-center'>
                            <div className='font-medium font-size4 color-text'>Follow-Up Recommendations</div>
                        </Col>
                        <Col md={1} className='d-flex justify-content-end align-items-center'>
                            <div className='icon-16 icon-dark icon-close' onClick={handleClose}></div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>
            <BzModalBody>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col>
                            <BzCard className='p-0' >
                                <Row className='g-0'>
                                    <Col md={9} className='d-flex justify-content-start align-items-center'>
                                        <div className='font-medium font-size4 color-text text-uppercase me-2' onClick={(e) => onClickOnRecommendationCard(followUpCompany, e)}>{followUpCompany?.scripInfo?.length && followUpCompany?.scripInfo[WATCHLIST_GRID_INDEX.SYMBOL]}</div> {/* Prachi T :BT-107377 - 23-11-2023 ScripInnfo recommendations - Start */}
                                        <div className='chips-wrap'>
                                            <BzChip className='exchange-chip me-2'>{followUpCompany?.exChangeName}</BzChip> {/* Prachi T :BT-107377 - 23-11-2023 ScripInnfo recommendations - Start */}
                                        </div>
                                        <WatchlistGridPopoverName arrRowData={followUpCompany?.scripInfo} />
                                        {followUpCompany?.isHoldings === true ? <div className='icon-16 icon-portfolio ms-2 icon-dark'></div> : null}{/* Prachi T :BT-107377 - 23-11-2023 ScripInnfo recommendations - Start */}
                                    </Col>
                                    {followUpCompany?.nBuySell ? <Col md={3} className='d-flex justify-content-end align-self-start'>
                                        <BzButton className={`btn ${isRecommendationExpired(followUpCompany?.status) ? 'btn-default cursor-not-allowed' : followUpCompany.nBuySell === "BUY" ? 'btn-positive' : 'btn-negative'} btn-sm text-capitalize`} onClick={(e) => handleRecommendationBuySellButton(followUpCompany, e)} disabled={isRecommendationExpired(followUpCompany?.status)}>{followUpCompany?.nBuySell}</BzButton> {/* Prachi T :BT-107377 - 23-11-2023 ScripInnfo recommendations - Start */}
                                    </Col> : <></>}
                                </Row>
                                <Row className='g-0 mt-2'>
                                    <Col className='d-flex jusitfy-content-start align-items-center flex-wrap'>
                                        <div className='chips-wrap'>
                                            {
                                                followUpCompany?.sRecoTag?.length > 0 &&
                                                <BzChip className='chips default-chip me-2 mb-2'>{followUpCompany?.sRecoTag}</BzChip> //Prachi T :BT-107377 - 23-11-2023 ScripInnfo recommendations - Start
                                            }
                                            {
                                                followUpCompany?.dontMiss && <DontMissChip value={followUpCompany?.dontMiss} isShowAllChips /> //Prachi T :BT-107377 - 23-11-2023 ScripInnfo recommendations - Start
                                            }
                                        </div>
                                    </Col>
                                </Row>
                                <Row className='recocard g-0 mt-2 align-items-center p-2'>
                                    <Col className='d-flex justify-content-start'>
                                        <div className='font-medium font-size3 color-text'>
                                            {followUpCompany?.sRecoDetails?.length >= 1 && (!followUpCompany?.sRecoDetails[0]?.nBuySell || followUpCompany?.sRecoDetails[0]?.showRecoText) ?
                                                <span>{followUpCompany?.sRecoDetails[0]?.sFormattedReco}</span>
                                                : <PriceFormat eachCompany={followUpCompany} />}
                                        </div> {/* Prachi T :BT-107377 - 23-11-2023 ScripInnfo recommendations - Start  */}
                                    </Col>
                                </Row>
                                <Row className='g-0 mt-4'>
                                    <Col md={6} className='justify-content-start align-self-start'>
                                        <div className='font-regular font-size1 color-text'>Recommendation on</div>
                                        <div className='font-regular font-size2 color-subtext'>{followUpCompany?.entryDate}</div> {/* Prachi T :BT-107377 - 23-11-2023 ScripInnfo recommendations - Start  */}
                                    </Col>
                                    <Col md={6} className='justify-content-end align-self-start text-end'>
                                        <div className='font-regular font-size1 color-text'>Valid till</div>
                                        <div className='font-regular font-size2 color-subtext'>{followUpCompany?.expiryDate}</div> {/* Prachi T :BT-107377 - 23-11-2023 ScripInnfo recommendations - Start  */}
                                    </Col>
                                </Row>
                                {followUpCompany?.sRecoDetails?.length >= 1 && followUpCompany?.sURL ? // Prachi T :BT-107377 - 23-11-2023 ScripInnfo recommendations - Start 
                                    <Row className='g-0 mt-3 align-items-center'>
                                        <Col className='d-flex justify-content-start'>
                                            <div className='d-flex cursor-pointer' onClick={() => openAnalyticReport(followUpCompany?.sURL)}> {/* Prachi T :BT-107377 - 23-11-2023 ScripInnfo recommendations - Start  */}
                                                <div className='icon-20 icon-pdf background-textual-link-withicon me-2'></div>
                                                <div className='font-medium font-size3 color-textual-link-withicon'>Analytic Report</div>
                                            </div>
                                        </Col>
                                    </Row>
                                    : <></>}
                                {
                                    followUpCompany?.sRecoDetails?.length > 0 && // Prachi T :BT-107377 - 23-11-2023 ScripInnfo recommendations - Start 
                                    <Row className='g-0 mt-3 align-items-center'>
                                        <Col className='d-flex justify-content-start'>
                                            <div className='d-flex align-items-center cursor-pointer'>
                                                <div className='notification-count font-regular'>{followUpCompany?.sRecoDetails?.length}</div> {/* Prachi T :BT-107377 - 23-11-2023 ScripInnfo recommendations - Start  */}
                                                <div className='font-regular font-size3 color-text ms-2'>Follow-up Recommendations</div>
                                            </div>
                                        </Col>
                                    </Row>
                                }
                            </BzCard>
                        </Col>
                    </Row>

                    <Row className='g-0'>
                        <Col>
                            <div className='progress-wrapper mt-3'>
                                <ul className='StepProgress'>
                                    {
                                        followUpCompany?.sRecoDetails?.map((eachChild, i) => (// Prachi T :BT-107377 - 23-11-2023 ScripInnfo recommendations - Start 
                                            <li key={i} className='StepProgress-item'>
                                                <Row className='g-0 mb-2'>
                                                    <Col className='d-flex justify-content-start'>
                                                        <div className='font-regular font-size4 color-text text-wrap'>{eachChild.sFormattedReco}</div>
                                                    </Col>
                                                </Row>
                                                {eachChild?.nBuySell ? <Row className='g-0 mb-2'>
                                                    <Col className='d-flex justify-content-start'>
                                                        <BzButton className={`btn ${isRecommendationExpired(followUpCompany?.status) ? 'btn-default cursor-not-allowed' : eachChild.nBuySell === "BUY" ? 'btn-positive' : 'btn-negative'} btn-sm text-capitalize`} onClick={(e) => handleChildRecommendationBuySellButton(eachChild, e, followUpCompany?.scripInfo)} disabled={isRecommendationExpired(followUpCompany?.status)}>{eachChild.nBuySell}</BzButton> {/* Prachi T :BT-107377 - 23-11-2023 ScripInnfo recommendations - Start  */}
                                                    </Col>
                                                </Row> : <></>}
                                                <Row className='g-0'>
                                                    <Col className='d-flex justify-content-start'>
                                                        <div className='font-regular font-size2 color-subtext'>{eachChild.dEnteredTime}</div>
                                                    </Col>
                                                </Row>
                                            </li>
                                        ))
                                    }
                                </ul>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </BzModalBody>
        </BzModal>
    );
};
export default memo(FollowUpModal);